import React from 'react';
import { Descriptions, Spin } from 'antd';
import strings from '../../utils/strings';
import { useReportsStore } from '../../store/slices/createReportsSlice';

export default function IssueEndorsementTotal() {
    const reports = useReportsStore()
    const data = reports.issueEndorsement.data.SummaryReport;
    const loading = reports.issueEndorsement.loading;
    const descriptionStyles = {
        label: { display: 'inline-block', width: 160 },
    };
    // const issueEndorsement = reports.issueEndorsement.data.DetailReport);

    if (!data) {
        return <div></div>
    }
    const items = [
        { label: 'تعداد الحاقیه', value: <>{strings.getFarsiNum(data.PayCount)}&nbsp;</> },
        { label: 'جمع مبلغ الحاقیه', value: <>{strings.currencyFormat(data.TotalAmount)}&nbsp;ریال</> },
        { label: 'جمع مبلغ تخفیفات', value: <>{strings.currencyFormat(data.TotalSumDiscountAmount)}&nbsp;ریال</> },
        { label: 'جمع مبلغ کارمزد', value: <>{strings.currencyFormat(data.TotalBusinessWageAmount)}&nbsp;ریال</> },
        { label: 'جمع مبلغ مالیات', value: <>{strings.currencyFormat(data.TotalTaxAmount)}&nbsp;ریال</> },
    ];
    return (
        <Spin style={{ marginTop: "30px" }} spinning={loading}>
            <div className="issue-endorsement-total-items">
                {items.map(({ label, value }) => (
                    <div className="issue-endorsement-total-item" key={label}>
                        <Descriptions bordered size="small" styles={descriptionStyles}>
                            <Descriptions.Item label={label}>{value}</Descriptions.Item>
                        </Descriptions>
                    </div>
                ))}
            </div>
        </Spin>
    );
}
